import MaintenancePage from './MaintenancePageSFC'
export default MaintenancePage
